function waitForFonts() {
  return typeof document !== 'undefined' && document.fonts?.ready
    ? document.fonts.ready.catch(() => undefined)
    : Promise.resolve();
}

function fits(el, text, maxHeightPx) {
  el.textContent = text;
  return el.scrollHeight <= maxHeightPx;
}

export async function ellipsizeToFit({ element, fullText, maxHeightPx }) {
  if (!element)
    return {
      text: fullText ?? '',
      isTruncated: false,
    };
  const value = String(fullText ?? '');

  await waitForFonts();

  const previousVisibility = element.style.visibility;
  element.style.visibility = 'hidden';

  if (!value) {
    element.textContent = '';
    element.style.visibility = previousVisibility;
    return { text: '', isTruncated: false };
  }

  if (fits(element, value, maxHeightPx)) {
    element.style.visibility = previousVisibility;
    return { text: value, isTruncated: false };
  }

  const ellipsis = '...';

  let low = 0;
  let high = value.length;
  let best = '';

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const candidate = `${value.slice(0, mid).trimEnd()}${ellipsis}`;

    if (fits(element, candidate, maxHeightPx)) {
      best = candidate;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  if (!best) {
    element.textContent = ellipsis;
    element.style.visibility = previousVisibility;
    return { text: ellipsis, isTruncated: true };
  }

  element.textContent = best;
  element.style.visibility = previousVisibility;
  return { text: best, isTruncated: true };
}
